import { Route } from "react-router-dom";

import {
  ADD_WEEKLY_WORKER_PAYMENT,
  ADD_WORK,
  EDIT_BULK_WORK,
  EDIT_WEEKLY_WORKER_PAYMENT,
  EDIT_WORK,
  VIEW_WEEKLY_WORKER_PAYMENT,
  VIEW_WEEKLY_WORKER_PAYMENT_REPORT,
  VIEW_WORKER,
  VIEW_WORKER_STATEMENT,
} from "src/constants";
import { AddBulkWorkerPayment, WeeklyPaymentHistory, WeeklyPaymentReport } from "src/pages/transaction";
import { WEEKLY_WORKER_PAYMENT_ROUTES } from "src/pages/transaction/constants";
import { WORKER_ROUTES } from "src/pages/worker/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { AddEditBulkWork } from "./AddEditBulkWork.page";
import { AddEditWork } from "./AddEditWork.page";
import { SingleWorker } from "./SingleWorker.page";
import { WorkDetails } from "./WorkDetails.page";
import { WorkerParticularsPage } from "./WorkerParticulars.page";
import { WorkerReceipt } from "./WorkerReceipt.page";
import { Workers } from "./Workers.page";

/** Route tree for the worker module, mounted under `/workers`, `/worker`, `/add-work` and `/edit-work`. */
export const workerRoutes = (
  <>
    <Route path={WORKER_ROUTES.root} element={<ProtectedRoute permissions={VIEW_WORKER} component={Workers} />} />
    <Route path={WORKER_ROUTES.details} element={<ProtectedRoute permissions={VIEW_WORKER} component={SingleWorker} />} />
    <Route
      path={WORKER_ROUTES.particulars}
      element={<ProtectedRoute permissions={VIEW_WORKER} component={WorkerParticularsPage} />}
    />
    <Route path={WORKER_ROUTES.addWork} element={<ProtectedRoute permissions={ADD_WORK} component={AddEditWork} />} />
    <Route path={WORKER_ROUTES.addWorkEntry} element={<ProtectedRoute permissions={ADD_WORK} component={AddEditWork} />} />
    <Route path={WORKER_ROUTES.editWork} element={<ProtectedRoute permissions={EDIT_WORK} component={AddEditWork} />} />
    <Route
      path={WORKER_ROUTES.editWorkBulk}
      element={<ProtectedRoute permissions={EDIT_BULK_WORK} component={AddEditBulkWork} />}
    />
    <Route
      path={WORKER_ROUTES.payment}
      element={<ProtectedRoute permissions={VIEW_WORKER_STATEMENT} component={WorkerReceipt} />}
    />
    <Route path={WORKER_ROUTES.work} element={<ProtectedRoute permissions={VIEW_WORKER_STATEMENT} component={WorkDetails} />} />

    <Route
      path={WEEKLY_WORKER_PAYMENT_ROUTES.root}
      element={<ProtectedRoute permissions={ADD_WEEKLY_WORKER_PAYMENT} component={AddBulkWorkerPayment} />}
    />
    <Route
      path={WEEKLY_WORKER_PAYMENT_ROUTES.history}
      element={<ProtectedRoute permissions={VIEW_WEEKLY_WORKER_PAYMENT} component={WeeklyPaymentHistory} />}
    />
    <Route
      path={WEEKLY_WORKER_PAYMENT_ROUTES.session}
      element={<ProtectedRoute permissions={EDIT_WEEKLY_WORKER_PAYMENT} component={AddBulkWorkerPayment} />}
    />
    <Route
      path={WEEKLY_WORKER_PAYMENT_ROUTES.report}
      element={<ProtectedRoute permissions={VIEW_WEEKLY_WORKER_PAYMENT_REPORT} component={WeeklyPaymentReport} />}
    />
  </>
);
